import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/home-left-pattern.svg'
import _imports_1 from '../assets/home-right-pattern.svg'


const _hoisted_1 = { class: "landing-grid" }
const _hoisted_2 = { class: "welcomeLeft" }
const _hoisted_3 = { class: "welcomeRight" }
const _hoisted_4 = { style: {"display":"inline-block"} }
const _hoisted_5 = {
  key: 1,
  id: "continue-button",
  disabled: ""
}
const _hoisted_6 = { class: "overview-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DPageTitle = _resolveComponent("DPageTitle")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DPageTitle, { title: "Welcome!" }),
      _cache[0] || (_cache[0] = _createElementVNode("p", null, " Just adding some test text to see how this will look on the page. A random encouraging phrase will go here. ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Want to continue where you left off?", -1)),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.userProgress?.next_section)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              id: "continue-button",
              to: {
            name: 'LessonIntro',
            params: {
              lessonId: _ctx.userProgress.current_lesson?.id,
              sectionId: _ctx.userProgress.next_section.id,
            },
          }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userProgress.next_section.title), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("button", _hoisted_5, " Nothing in progress yet "))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" Or, ", -1)),
          _createVNode(_component_router_link, { to: "/course-dashboard" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("go to course overview", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"resource\" data-v-91613dca><div class=\"resource-relative\" data-v-91613dca><img src=\"" + _imports_0 + "\" data-v-91613dca><div id=\"resource-link\" data-v-91613dca><a href=\"#\" data-v-91613dca>Resource Kit</a></div></div></div><div class=\"community\" data-v-91613dca><div class=\"community-relative\" data-v-91613dca><img src=\"" + _imports_1 + "\" data-v-91613dca><div id=\"community-link\" data-v-91613dca><a href=\"#\" data-v-91613dca>Community</a></div></div></div>", 2))
  ]))
}